
import {MenuFoldOutlined, MenuUnfoldOutlined} from '@ant-design/icons-vue';
import EleProSidebarItem from '../../ele-pro-sidebar-item';
import EleProSidebarMenus from '../../ele-pro-sidebar-menus';

export default {
  name: 'EleProSidebarNav',
  components: {
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    EleProSidebarItem,
    EleProSidebarMenus
  },
  emits: ['toggle-collapse'],
  props: {
    // 导航数据
    data: Array,
    // 导航选中
    active: Array,
    // 主题, light | dark
    theme: String,
    // 导航是否折叠
    collapse: Boolean,
    // 菜单是否折叠
    menuCollapse: Boolean,
    // 子级缩进
    inlineIndent: Number,
    // 是否显示折叠按钮
    showNavCollapse: Boolean,
    // 是否使用递归渲染菜单item
    useDeep: Boolean
  },
  data() {
    return {
      // 一级pop菜单class
      firstPopClass: 'ele-admin-sidebar-nav-menu-pop'
    };
  },
  computed: {
    // 是否折叠
    isCollapse() {
      return this.collapse || this.menuCollapse;
    }
  },
  methods: {
    /* 折叠展开侧栏 */
    toggleCollapse() {
      this.$emit('toggle-collapse');
    }
  }
}
